import { z } from 'zod';
export const ssoDomainsGuard = z.array(z.string());
export const ssoBrandingGuard = z.object({
    logo: z.string().optional(),
    darkLogo: z.string().optional(),
});
